/**
 * 系统管理-组织管理
 * luxinwen
 * 2023-04-03
 */
<template>
  <div class="page">
    <div class="page-main">
      <div class="page-main-content">
        <Button type="primary" @click="addData" v-grant="'OSP_SYS_ORG_SAVE'">新增一级组织</Button>
        <Button type="info" @click="expand(true)">全部展开</Button>
        <Button type="info" @click="expand(false)">全部收起</Button>
      </div>
      <div class="page-main-content">
        <Tree class="tree-editor" :data="treeData" :render="renderContent" :select-node="false" @on-toggle-expand="toggleExpand"></Tree>
      </div>
    </div>

    <edit-drawer v-model="drawerDisplay" :data="drawerData" :flag="drawerFlag" @success="getData"></edit-drawer>
  </div>
</template>

<script>
  import editDrawer from './edit.vue';

  export default {
    components: {
      editDrawer
    },
    data() {
      return {
        treeData: [],
        drawerDisplay: false, // 是否显示编辑抽屉
        drawerData: {},       // 编辑抽屉数据
        drawerFlag: 'add',    // 编辑抽屉状态
        treeExpand: {},
        isExpand: true
      };
    },
    created() {
      this.getData();
    },
    methods: {
      /**
       * 获取数据
       */
      getData() {
        this.$axios({
          url: this.$api.system.queryOrgList,
          data: {},
          loading: true
        }).then(data => {
          let list = data || [];
          this.treeData = [];
          this.setTreeList(this.treeData, list);
        });
      },
      /**
       * 生成组织树数据格式
       */
      setTreeList(target = [], list = [], parentId = null) {
        list.filter(item => item.parentId === parentId).forEach(item => {
          let temp = {
            title: `${item.orgName} [${item.orgCode}]`,
            row: item,
            expand: this.treeExpand.hasOwnProperty(item.id) ? this.treeExpand[item.id] : this.isExpand,
            children: []
          };
          if (list.findIndex(node => node.parentId === item.id) !== -1) this.setTreeList(temp.children, list, item.id);
          target.push(temp);
        });
      },
      /**
       * 树形渲染函数
       */
      renderContent(h, { root, node, data }) {
        return h('span', {
          style: {
            display: 'inline-block',
            width: '100%'
          }
        }, [
          h('span', [
            h('Icon', {
              props: {
                type: data.children.length > 0 ? 'ios-folder-outline' : 'ios-paper-outline'
              },
              style: {
                marginRight: '8px'
              }
            }),
            h('span', data.title)
          ]),
          h('span', {
            style: {
              display: 'inline-block',
              float: 'right',
              marginRight: '32px'
            }
          }, [
            h('Button', {
              props: {
                type: 'info',
                size: 'small'
              },
              on: {
                click: () => {
                  this.addData(data.row);
                }
              },
              directives: [
                {
                  name: 'grant',
                  value: 'OSP_SYS_ORG_SAVE'
                }
              ]
            }, '添加下级组织'),
            h('Button', {
              props: {
                size: 'small'
              },
              on: {
                click: () => {
                  this.editData(root, data.row, true);
                }
              },
              directives: [
                {
                  name: 'grant',
                  value: 'OSP_SYS_ORG_VIEW'
                }
              ]
            }, '查看'),
            h('Button', {
              props: {
                size: 'small'
              },
              on: {
                click: () => {
                  this.editData(root, data.row, false);
                }
              },
              directives: [
                {
                  name: 'grant',
                  value: 'OSP_SYS_ORG_UPDATE'
                }
              ]
            }, '编辑'),
            h('Button', {
              props: {
                type: 'error',
                size: 'small'
              },
              on: {
                click: () => {
                  this.removeData(data);
                }
              },
              directives: [
                {
                  name: 'grant',
                  value: 'OSP_SYS_ORG_DELETE'
                }
              ]
            }, '删除')
          ])
        ]);
      },
      /**
       * 新增数据
       */
      addData(row) {
        let drawerData = {
          orgLevel: 1
        };
        if (row) {
          drawerData.parentId = row.id;
          drawerData.parentName = row.orgName;
          drawerData.orgLevel = row.orgLevel + 1;
        }
        this.drawerFlag = 'add';
        this.drawerData = drawerData;
        this.drawerDisplay = true;
      },
      /**
       * 查看、编辑数据
       */
      editData(root, row, onlyRoad = false) {
        let parent = null;
        if (row.parentId) {
          parent = root.find(item => item.node.row.id === row.parentId);
        }
        this.drawerFlag = onlyRoad ? 'show' : 'edit';
        this.drawerData = Object.assign({}, row, {
          parentName: parent ? parent.node.row.orgName : ''
        });
        this.drawerDisplay = true;
      },
      /**
       * 删除数据
       */
      removeData(data) {
        let title = `${data.row.orgName}[${data.row.orgCode}]`;
        if (data.children.length > 0) {
          this.notice(`${title}下还有下级组织，无法删除`);
          return;
        }
        this.$confirm(`确定要删除 ${title} 吗？`).then(() => {
          this.$axios({
            url: this.$api.system.deleteOrg,
            data: {
              id: data.row.id
            },
            loading: true
          }).then(data => {
            this.notice({
              type: 'success',
              desc: '删除成功'
            });
            this.getData();
          });
        });
      },
      /**
       * 展开、收缩节点
       */
      toggleExpand(data) {
        this.treeExpand[data.row.id] = data.expand;
      },
      /**
       * 全部展开或收起
       */
      expand(type) {
        this.isExpand = type;
        this.treeExpand = {};
        this.changeExpand(this.treeData);
      },
      /**
       * 遍历树数据更新状态
       */
      changeExpand(list) {
        list.forEach(item => {
          item.expand = this.isExpand;
          if (item.children.length > 0) {
            this.changeExpand(item.children);
          }
        });
      }
    }
  };
</script>